<template>
  <v-dialog
    v-model="value"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    @keydown.esc="$emit('input', false)"
  >
    <QuotationForm
      v-if="value"
      :quotationId="quotationId"
      :areaInterestId="areaInterestId"
      :projectId="projectId"
      :marketId="marketId"
      :type="type"
      @onSaveSuccess="onSaveSuccess"
      @onDismiss="dismiss"
    />
  </v-dialog>
</template>
<script>
import QuotationForm from "./QuotationForm.component.vue";
export default {
  props: {
    value: Boolean,
    type: String,
    quotationId: String,
    areaInterestId: String,
    projectId: String,
    marketId: String
  },
  components: {
    QuotationForm,
  },
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
    };
  },
  methods: {
    dismiss() {
      this.$emit("input", false);
    },
    onSaveSuccess(data) {
      this.$emit("onSaveSuccess", data);
    },
  },
};
</script>
<style lang="scss" scoped>
.card-receipt-form {
  height: calc(100vh - 110px);
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
